import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@base-app';
import { COMMUNITY_OUTREACH_TRANSLATION } from '../../constants/common';
import {
  StyledAlternativeContainer,
  StyledButtonContent,
  StyledHandledReset,
  StyledMessageContainer,
  StyledSubmitted,
  StyledSuccessIconOutreach,
  StyledSuccessPageContainer,
} from './SuccessPage.styles';
import { SuccessPageProps } from './SuccessPage.types';

const SuccessPage: FC<SuccessPageProps> = ({ outreachUrl, handleResetForm }) => {
  const { t } = useTranslation(COMMUNITY_OUTREACH_TRANSLATION);

  return (
    <StyledSuccessPageContainer>
      <StyledSuccessIconOutreach data-testid={'success-icon'} />
      <StyledSubmitted>{t('submited')}</StyledSubmitted>
      <StyledMessageContainer>{t('message')}</StyledMessageContainer>
      <StyledAlternativeContainer>{t('alternatively')}</StyledAlternativeContainer>
      <StyledButtonContent>
        <Button css={{ height: '$8' }} role={'continue-button'}>
          <a
            href={outreachUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'white', textDecoration: 'none' }}
          >
            {t('continue')}
          </a>
        </Button>
        <StyledHandledReset data-testid={'reset-link'} onClick={handleResetForm}>
          {t('add')}
        </StyledHandledReset>
      </StyledButtonContent>
    </StyledSuccessPageContainer>
  );
};

export default SuccessPage;
